import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { Development, Coding } from "../../constants";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import "./Work.scss";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";

const Work = () => {
  const [filterWork, setFilterWork] = useState([]);
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    setFilterWork(Development);
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === "Development") {
        setFilterWork(Development);
      } else {
        setFilterWork(Coding);
      }
    }, 500);
  };

  return (
    <div>
      <h2 className="head-text">Work</h2>
      <div className="app__work-filter app__flex">
        {["Development", "Coding Profiles"].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((project, index) => {
          return (
            <div className="app__work-item app__flex" key={index}>
              <div className="app__work-image app__flex">
                <img src={project.imageUrl} alt="project img"></img>

                <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{
                    duration: 0.25,
                    ease: "easeInOut",
                    staggerChildren: 0.5,
                  }}
                  className="app__work-hover app__flex"
                >
                  {project.ProjectLink.length > 0 && (
                    <a
                      href={project.ProjectLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                        className="app__flex"
                      >
                        <AiFillEye />
                      </motion.div>
                    </a>
                  )}
                  {project.codeLink.length > 0 && (
                    <a href={project.codeLink} target="_blank" rel="noreferrer">
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{ duration: 0.25 }}
                        className="app__flex"
                      >
                        <AiFillGithub />
                      </motion.div>
                    </a>
                  )}
                </motion.div>
              </div>
              <div className="app__work-content app__flex">
                <h4 className="bold-text">{project.title}</h4>
                <p className="p-text" style={{ marginTop: 10 }}>
                  {`${project.description.slice(0, 100)}...`}
                </p>
              </div>
            </div>
          );
        })}
      </motion.div>
    </div>
  );
};

export default AppWrap(MotionWrap(Work), "work", "app__whitebg");
